import { FunctionComponent, JSX } from 'react'
import { CheckCircleOutline, HourglassEmpty } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ConsentVote, FamilyConsentRequest } from '@/types/FamilyConsent'
import styles from './outgoingRequests.module.scss'

type OutgoingRequestsProps = {
    requests: FamilyConsentRequest[]
}

const OutgoingRequests: FunctionComponent<OutgoingRequestsProps> = ({ requests }: OutgoingRequestsProps) => {
    const { t } = useTranslation()

    if (requests.length === 0) {
        return <p className={styles.Empty}>{t('noOutgoingConsentRequests')}</p>
    }

    return (
        <div className={styles.List}>
            {requests.map(
                (request: FamilyConsentRequest): JSX.Element => (
                    <div key={request.id} className={styles.Card}>
                        <p className={styles.FamilyName}>{request.parentName}</p>
                        <div className={styles.Votes}>
                            {request.votes.map(
                                (vote: ConsentVote): JSX.Element => (
                                    <span
                                        key={vote.id}
                                        className={`${styles.Chip} ${vote.decision === 'accepted' ? styles.accepted : ''}`}
                                    >
                                        {vote.decision === 'accepted' ? (
                                            <CheckCircleOutline fontSize='small' />
                                        ) : (
                                            <HourglassEmpty fontSize='small' />
                                        )}
                                        {vote.daycareName}
                                    </span>
                                )
                            )}
                        </div>
                    </div>
                )
            )}
        </div>
    )
}

export default OutgoingRequests
